import React, { forwardRef } from "react";
import clsx from "clsx";

const Input = forwardRef(({
  label,
  error,
  helperText,
  leftIcon,
  rightIcon,
  fullWidth = true,
  className = "",
  inputClassName = "",
  disabled = false,
  required = false,
  id,
  ...props
}, ref) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className={clsx(fullWidth ? "w-full" : "inline-block", className)}>
      {label && (
        <label
          htmlFor={inputId}
          className="block text-sm font-medium text-dark-700 dark:text-dark-300 mb-1"
        >
          {label}
          {required && <span className="text-danger-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative">
        {leftIcon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none text-dark-400">
            {leftIcon}
          </div>
        )}
        <input
          ref={ref}
          id={inputId}
          disabled={disabled}
          className={clsx(
            "w-full px-3 py-2 text-sm border rounded-lg",
            "bg-white dark:bg-dark-800",
            "text-dark-900 dark:text-dark-100",
            "placeholder-dark-400 dark:placeholder-dark-500",
            "transition-colors duration-200",
            "disabled:bg-dark-100 disabled:dark:bg-dark-700 disabled:cursor-not-allowed",
            "focus:outline-none focus:ring-2 focus:ring-offset-0",
            error
              ? "border-danger-500 focus:border-danger-500 focus:ring-danger-500/20"
              : "border-dark-300 dark:border-dark-600 focus:border-primary-500 focus:ring-primary-500/20",
            leftIcon && "pl-10",
            rightIcon && "pr-10",
            inputClassName
          )}
          {...props}
        />
        {rightIcon && (
          <div className="absolute inset-y-0 right-0 pr-3 flex items-center text-dark-400">
            {rightIcon}
          </div>
        )}
      </div>
      {(error || helperText) && (
        <p
          className={clsx(
            "mt-1 text-xs",
            error ? "text-danger-500" : "text-dark-500 dark:text-dark-400"
          )}
        >
          {error || helperText}
        </p>
      )}
    </div>
  );
});

Input.displayName = "Input";

export default Input;
